import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DownOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { DatePicker, Select, Input, Tooltip, Button } from 'antd';
import { mergeSearchParams } from '~helpers/history';
import SearchComponent from '~components/search-component';
import { PropertySearchSelector } from '~components/special-offer/map/offer-map-by-property/property-list-editor/components/select-property-by-property';
import { dayFormatType, formatDay } from '~helpers/day';

const landlordPageSize = 20;

export default class ContractFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLandlords: [],
      searchComponentVisible: true,
      filterForm: {
        landlord: [],
        signedDate: [],
        contractStatus: '',
        property: null,
      },
      landlordPageNumber: 1,
      landlordList: [],
      query: '',
      isLoading: false,
      hasMore: true,
    };

    this.hasMore = true;
  }

  formatFilters = filters => ({
    landlordSlugs: filters.landlord || null,
    pageNumber: Number(filters.pageNumber) || null,
    pageSize: Number(filters.pageSize) || null,
    statuses: filters.contractStatus ? filters.contractStatus.toUpperCase() : null,
    signedDateStart:
      filters.signedDate.length > 0
        ? formatDay(dayFormatType.FILTERPARAMS, filters.signedDate[0])
        : null,
    signedDateEnd:
      filters.signedDate.length > 0
        ? formatDay(dayFormatType.FILTERPARAMS, filters.signedDate[1])
        : null,
    sortDirection: filters.sortDirection || null,
    orPropertyLevel: filters.property ? { propertyId: filters.property.id } : null,
    levels: filters.property ? 'LANDLORD' : null,
    landlordIds: filters.property ? [filters.property.landlordId] : null,
  });

  inquireFilter = () => {
    const { filterForm } = this.state;
    const queryParams = this.formatFilters(filterForm);
    this.pushState(queryParams);
    this.props.getContractList(queryParams);
    this.props.setPageParams();
  };

  pushState = data => {
    this.props.history.push(mergeSearchParams(data, this.props.defaultSearchParams));
  };

  setFilterForm = (data, type) => {
    this.state.filterForm[type] = data;
  };

  resetFilter = () => {
    this.props.form.resetFields();
    this.state.filterForm = {
      landlord: [],
      signedDate: [],
      contractStatus: '',
      property: null,
    };

    this.setState(this.state);
    this.searchComponent.handleClear();

    const inputItem = document.querySelector('.search-component__input');
    if (inputItem) {
      inputItem.value = '';
    }
    this.inquireFilter();
  };

  changeFilter = () => {
    this.props.changeFilterState();
  };

  handleSearch = value => {
    this.setState({
      isLoading: true,
    });
    this.props.searchLandlordList(value, 1, landlordPageSize, res => {
      this.setState({
        landlordList: (res?.search?.edges || []).map(landlord => landlord.node),
        landlordPageNumber: 1,
        query: value,
        isLoading: false,
        hasMore: res?.search?.edges.length >= landlordPageSize,
      });
    });
  };

  handleScrollEnd = () => {
    if (!this.state.hasMore) return;
    this.setState({
      isLoading: true,
    });
    this.props.searchLandlordList(
      this.state.query,
      this.state.landlordPageNumber + 1,
      landlordPageSize,
      res => {
        this.setState(prevState => ({
          landlordList: [
            ...prevState.landlordList,
            ...res?.search?.edges?.map(landlord => landlord.node),
          ],
          landlordPageNumber: prevState.landlordPageNumber + 1,
          isLoading: false,
          hasMore: res?.search?.edges.length >= landlordPageSize,
        }));
      },
    );
  };

  render() {
    const { filterForm } = this.state;
    const { form, t, isEmpty, filterState: isExpand, isLarge: isLargeScreen } = this.props;

    const { getFieldDecorator, setFieldsValue } = form;
    const { RangePicker } = DatePicker;
    const dateFormat = dayFormatType.UKFORMAT;

    return (
      <div className={classNames('contract-filter', { 'contract-filter__content-empty': isEmpty })}>
        <div
          className={classNames('contract-filter__container', {
            'contract-filter__container--flex-warp': isExpand,
            'contract-filter__container--flex-column': !isLargeScreen,
          })}
        >
          <div
            className={classNames('contract-filter__box', {
              'contract-filter__box--w-405 contract-filter__box--flex-grow':
                !isExpand && isLargeScreen,
              'contract-filter__box--w-half': isExpand && isLargeScreen,
            })}
          >
            <span
              className={classNames('contract-filter__title', {
                'contract-filter__title-empty': isEmpty,
              })}
            >
              {t('cms.table.column.landlord')}:
            </span>
            <Form.Item>
              {getFieldDecorator('landlord', {
                validateTrigger: 'onChange',
              })(
                <Input
                  className="combined-search-component__input"
                  ref={node => {
                    this.targetInput = node.input;
                  }}
                  disabled={isEmpty}
                  placeholder={t('cms.contract.filter.landlord_name.placeholder')}
                />,
              )}
              <If condition={this.state.selectedLandlords.length}>
                <Tooltip
                  arrowPointAtCenter
                  placement="topRight"
                  title={this.state.selectedLandlords.map(item => (
                    <div key={item.id} className="indicator-text">
                      {item.name}
                    </div>
                  ))}
                >
                  <div className="indicator">{this.state.selectedLandlords.length}</div>
                </Tooltip>
              </If>
              <If condition={this.state.searchComponentVisible}>
                <SearchComponent
                  t={t}
                  isLoadingByScroll={true}
                  isFetching={this.state.isLoading}
                  targetInput={this.targetInput}
                  container={this.searchComponentContainer}
                  options={this.state.landlordList}
                  type={'input'}
                  keyValue="id"
                  className="search-component"
                  ref={node => {
                    this.searchComponent = node;
                  }}
                  showSelectAll={false}
                  onChange={value => {
                    const field = {};
                    field.landlord = value.value.map(item => item.name).join('; ');
                    setFieldsValue(field);
                    this.setState({
                      selectedLandlords: value.value,
                    });
                    filterForm.landlord = value.value.map(item => item.slug);
                  }}
                  onSearch={this.handleSearch}
                  onScrollEnd={this.handleScrollEnd}
                />
              </If>
            </Form.Item>
          </div>
          <div
            className={classNames('contract-filter__box', {
              'contract-filter__box--w-405': !isExpand && isLargeScreen,
              'contract-filter__box--w-half': isExpand && isLargeScreen,
            })}
          >
            <span
              className={classNames('contract-filter__title', {
                'contract-filter__title-empty': isEmpty,
              })}
            >
              {t('cms.contract.filter.contract_status')}:
            </span>
            <Form.Item>
              {getFieldDecorator('contractStatus', {
                validateTrigger: 'onChange',
                initialValue: filterForm.contractStatus ? filterForm.contractStatus : undefined,
              })(
                <Select
                  className="contract-filter__common-size"
                  disabled={isEmpty}
                  onChange={data => this.setFilterForm(data, 'contractStatus')}
                  placeholder={t('cms.contract.filter.contract_status.placeholder')}
                >
                  <Select.Option
                    value="inactive"
                    label={t('cms.property.commission.list.status.inactive')}
                  >
                    <span
                      className="contract-filter__circle"
                      style={{ backgroundColor: '#f9b495' }}
                    />
                    {t('cms.property.commission.list.status.inactive')}
                  </Select.Option>
                  <Select.Option
                    value="active"
                    label={t('cms.property.commission.list.status.active')}
                  >
                    <span
                      className="contract-filter__circle"
                      style={{ backgroundColor: '#4db253' }}
                    />
                    {t('cms.property.commission.list.status.active')}
                  </Select.Option>
                  <Select.Option
                    value="expire"
                    label={t('cms.property.commission.list.status.expire')}
                  >
                    <span
                      className="contract-filter__circle"
                      style={{ backgroundColor: '#c8c9cb' }}
                    />
                    {t('cms.property.commission.list.status.expire')}
                  </Select.Option>
                </Select>,
              )}
            </Form.Item>
          </div>
          <If condition={isExpand}>
            <div
              className={classNames('contract-filter__box', {
                'contract-filter__box--w-390': isLargeScreen,
              })}
              ref={node => {
                this.signData = node;
              }}
            >
              <span
                className={classNames('contract-filter__title', {
                  'contract-filter__title-empty': isEmpty,
                })}
              >
                {t('cms.contract.filter.signed_date')}:
              </span>
              <Form.Item>
                {getFieldDecorator('signedDate', {
                  validateTrigger: 'onChange',
                })(
                  <RangePicker
                    className="contract-filter__common-size"
                    getCalendarContainer={() => this.signData}
                    format={dateFormat}
                    disabled={isEmpty}
                    onChange={data => this.setFilterForm(data, 'signedDate')}
                  />,
                )}
              </Form.Item>
            </div>
            <div
              className={classNames('contract-filter__box', {
                'contract-filter__box--w-390': isLargeScreen,
                'contract-filter__box--flex-grow': isLargeScreen && isExpand,
              })}
            >
              {/* PropertySearchSelector */}
              <span
                className={classNames('contract-filter__title', {
                  'contract-filter__title-empty': isEmpty,
                })}
              >
                {t('cms.contract.filter.property_name')}:
              </span>
              <Form.Item>
                {getFieldDecorator('property', {
                  validateTrigger: 'onChange',
                  valuePropName: 'selectedProperty',
                })(
                  <PropertySearchSelector
                    className="contract-filter__common-size"
                    propertyStatusFilter="ALL"
                    onSelect={(newValue, option) => {
                      setFieldsValue({
                        property: newValue,
                      });
                      this.setFilterForm(
                        {
                          id: newValue,
                          landlordId: option.landlord.id,
                        },
                        'property',
                      );
                    }}
                  />,
                )}
              </Form.Item>
            </div>
          </If>
          <div
            className={classNames('contract-filter__inquire', {
              'contract-filter__box--w-235': isExpand && isLargeScreen,
              'contract-filter__box--w-222 contract-filter__box--flex-grow':
                !isExpand && isLargeScreen,
              'contract-filter__box--justify-end': !isLargeScreen,
            })}
          >
            <Button.Group className="contract-filter__button-group">
              <Button onClick={this.resetFilter}>{t('cms.contract.filter.reset')}</Button>
              <Button type="primary" onClick={this.inquireFilter}>
                {t('cms.contract.filter.inquire')}
              </Button>
            </Button.Group>
            <div
              role="button"
              tabIndex="0"
              className={classNames('contract-filter__down', {
                'contract-filter__down-empty': isEmpty,
                'contract-filter__down--expand': isExpand,
              })}
            >
              <span onClick={isEmpty ? null : this.changeFilter}>Expand</span>
              <DownOutlined />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContractFilter.propTypes = {
  isLarge: PropTypes.bool.isRequired,
  filterState: PropTypes.bool.isRequired,
  changeFilterState: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  landlordList: PropTypes.array,
  history: PropTypes.object.isRequired,
  getContractList: PropTypes.func.isRequired,
  setPageParams: PropTypes.func.isRequired,
  defaultSearchParams: PropTypes.object.isRequired,
};

ContractFilter.defaultProps = {
  landlordList: [],
};
